import type { MenuItemSearchParams } from '@/lib/api/requests/menu-items';

const EMPTY_PARAMS: MenuItemSearchParams = {} as MenuItemSearchParams;

export const menuItemKeys = {
  all: ['menu-items'] as const,
  lists: () => [...menuItemKeys.all, 'list'] as const,
  list: (params?: MenuItemSearchParams) =>
    [...menuItemKeys.lists(), params ?? EMPTY_PARAMS] as const,
  details: () => [...menuItemKeys.all, 'detail'] as const,
  detail: (id: number) => [...menuItemKeys.details(), id] as const,
  menus: () => [...menuItemKeys.all, 'menus'] as const,
};
